import {
  mapSelfIpoApplicationFromApi,
  mapSelfIpoOfferingDetailFromApi,
  mapSelfIpoOfferingFromApi,
  mapSelfIpoPortfolioFromApi,
} from 'rtkQuery/sharespro/mapper/modules/selfIpo/mapSelfIpoFromApi';
import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';

export const selfIpoApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSelfIpoOfferings: builder.query<SelfIpoOffering[], void>({
      query: () => ({
        url: '/v3/ipo/self-ipo/offerings',
        method: 'GET',
        sendToken: true,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiSelfIpoOfferingListResponse>
      ) {
        return baseQueryReturnValue.data.items.map(mapSelfIpoOfferingFromApi);
      },
    }),
    fetchSelfIpoOfferingDetail: builder.query<SelfIpoOfferingDetail, ID>({
      query: (id) => ({
        url: '/v3/ipo/self-ipo/offering-detail',
        method: 'GET',
        sendToken: true,
        params: { id },
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiSelfIpoOfferingDetailResponse>
      ) {
        return mapSelfIpoOfferingDetailFromApi(baseQueryReturnValue.data);
      },
    }),
    fetchSelfIpoPortfolio: builder.query<SelfIpoPortfolio | null, void>({
      query: () => ({
        url: '/v3/ipo/self-ipo/portfolio',
        method: 'GET',
        sendToken: true,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiSelfIpoPortfolioResponse>
      ) {
        return baseQueryReturnValue.data.portfolio
          ? mapSelfIpoPortfolioFromApi(baseQueryReturnValue.data.portfolio)
          : null;
      },
    }),
    fetchSelfIpoApplications: builder.query<SelfIpoApplication[], void>({
      query: () => ({
        url: '/v3/ipo/self-ipo/applications',
        method: 'GET',
        sendToken: true,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiSelfIpoApplicationListResponse>
      ) {
        return baseQueryReturnValue.data.items.map(
          mapSelfIpoApplicationFromApi
        );
      },
    }),
    applySelfIpo: builder.mutation<
      SelfIpoApplication,
      ApiSelfIpoApplyRequestData
    >({
      query: (body) => ({
        url: '/v3/ipo/self-ipo/apply',
        method: 'POST',
        sendToken: true,
        body,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiSelfIpoApplyResponse>
      ) {
        return mapSelfIpoApplicationFromApi(
          baseQueryReturnValue.data.application
        );
      },
    }),
    cancelSelfIpoApplication: builder.mutation<
      boolean,
      ApiSelfIpoCancelRequestData
    >({
      query: (body) => ({
        url: '/v3/ipo/self-ipo/cancel',
        method: 'POST',
        sendToken: true,
        body,
      }),
    }),
    applySelfIpoOffering: builder.mutation<
      boolean,
      ApiSelfIpoOfferingActionRequestData
    >({
      query: (body) => ({
        url: '/v3/ipo/self-ipo/apply-offering',
        method: 'POST',
        sendToken: true,
        body,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiSelfIpoActionResponse>
      ) {
        return baseQueryReturnValue.data.result;
      },
    }),
    topUpSelfIpo: builder.mutation<
      boolean,
      ApiSelfIpoOfferingActionRequestData
    >({
      query: (body) => ({
        url: '/v3/ipo/self-ipo/top-up',
        method: 'POST',
        sendToken: true,
        body,
      }),
      transformResponse(
        baseQueryReturnValue: SharesproApiResponse<ApiSelfIpoActionResponse>
      ) {
        return baseQueryReturnValue.data.result;
      },
    }),
  }),
});

export const {
  useApplySelfIpoOfferingMutation,
  useFetchSelfIpoOfferingsQuery,
  useFetchSelfIpoOfferingDetailQuery,
  useFetchSelfIpoPortfolioQuery,
  useFetchSelfIpoApplicationsQuery,
  useApplySelfIpoMutation,
  useCancelSelfIpoApplicationMutation,
  useTopUpSelfIpoMutation,
} = selfIpoApi;
